"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlLocaleSource = void 0;
const supported_locales_utility_1 = require("../supported-locales-utility");
class UrlLocaleSource {
    getLocale() {
        const urlParams = new URLSearchParams(window.location.search);
        let locale = urlParams.get(UrlLocaleSource.URL_PARAM_KEY);
        if (!locale || !supported_locales_utility_1.SupportedLocales.isLocaleSupported(locale)) {
            return null;
        }
        return supported_locales_utility_1.SupportedLocales.normalizeLocale(locale);
    }
}
exports.UrlLocaleSource = UrlLocaleSource;
UrlLocaleSource.URL_PARAM_KEY = 'lang';
//# sourceMappingURL=url-locale-source.js.map